import { render, staticRenderFns } from "./PatientData.vue?vue&type=template&id=5c64dc29&lang=pug&"
import script from "./PatientData.vue?vue&type=script&lang=js&"
export * from "./PatientData.vue?vue&type=script&lang=js&"
import style0 from "./PatientData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports